import { render, staticRenderFns } from "./ClockForProject.vue?vue&type=template&id=6267a910&"
import script from "./ClockForProject.vue?vue&type=script&lang=js&"
export * from "./ClockForProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports